import { useReducer } from 'react';
import reducer, { generateInitialState } from './reducer';
import MetricsInspectionContext from './context';

const MetricsInspectionProvider = ({
  widget,
  period,
  filters,
  children,
  isPublic
}) => {
  const [state, dispatch] = useReducer(
    reducer,
    generateInitialState({
      widget,
      period,
      filters,
      isPublic
    })
  );

  return (
    <MetricsInspectionContext.Provider value={{ state, dispatch }}>
      {children}
    </MetricsInspectionContext.Provider>
  );
};

export default MetricsInspectionProvider;
